import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Search, Close } from '@mui/icons-material';
import { Grid } from '@mui/material';
import { TextField, Button } from '@totalsoft/rocket-ui';
import { DateTime } from '@ts-private/rocket-extensions';

const FacilityListFilters = ({ filters, onChangeFilterValue }) => {
  const { t } = useTranslation();

  const resetFilters = name => () => {
    const value = '';
    onChangeFilterValue(name, value);
  };

  const onChangeFilterValueHandler = name => value => onChangeFilterValue(name, value);

  const onDateTimeFilterChanged = name => value => {
    onChangeFilterValue(name, value === null ? null : value, true);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} lg={4}>
        <TextField
          fullWidth
          label={t('Facility.FacilityNumber')}
          value={filters.facilityNumber || ''}
          onChange={onChangeFilterValueHandler('facilityNumber')}
          startAdornment={<Search />}
          endAdornment={
            <Button onClick={resetFilters('facilityNumber')} variant='text' tooltip={t('Tooltips.ResetFilters')}>
              <Close />
            </Button>
          }
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={4}>
        <TextField
          fullWidth
          label={t('Facility.PartnerName')}
          value={filters.partnerName || ''}
          onChange={onChangeFilterValueHandler('partnerName')}
          inputProps={{
            maxLength: 255
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={4}>
        <TextField
          fullWidth
          label={t('Facility.PartnerGroupName')}
          value={filters.partnerGroupName || ''}
          onChange={onChangeFilterValueHandler('partnerGroupName')}
          inputProps={{
            maxLength: 255
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={4}>
        <DateTime
          value={filters.validFrom}
          label={t('Facility.ValidFrom')}
          onChange={onDateTimeFilterChanged('validFrom')}
          isClearable
          timeFormat={false}
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={4}>
        <DateTime
          value={filters.validUntil}
          label={t('Facility.ValidUntil')}
          onChange={onDateTimeFilterChanged('validUntil')}
          isClearable
          timeFormat={false}
        />
      </Grid>
    </Grid>
  );
};

FacilityListFilters.propTypes = {
  filters: PropTypes.object.isRequired,
  onChangeFilterValue: PropTypes.func.isRequired
};

export default FacilityListFilters;
